/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import TransactionalMessageModel, { TransactionalMessageChannelType } from 'cio/models/transactional-message';

interface TransactionalMessagePreviewArgs {
  message: TransactionalMessageModel;
  readOnly: boolean;
}

export default class TransactionalMessagePreview extends Component<TransactionalMessagePreviewArgs> {
  get isEmail() {
    return this.args.message.type === TransactionalMessageChannelType.Email;
  }
}
